import React from 'react';
import { useSelector } from 'react-redux';
import { FaExclamationCircle, FaCreditCard } from 'react-icons/fa';

const SubscriptionBanner = ({ quota }) => {
    if (!quota || quota.isPaid !== false || (quota.lastPaymentAmount || 0) <= 0) {
        return null;
    }

    return (
        <div className="alert alert-danger d-flex align-items-center mb-0 border-0 rounded-0" style={{ zIndex: 1100 }}>
            <FaExclamationCircle className="me-2 text-danger" size={20} />
            <div className="d-flex flex-grow-1 align-items-center justify-content-between">
                <span>
                    <strong>Payment Due:</strong> An outstanding balance of
                    <span className="fw-bold ms-1 text-danger">Rs. {quota.lastPaymentAmount?.toLocaleString()}</span> is pending.
                    Please settle this to avoid service interruption.
                </span>
                <button
                    className="btn btn-sm btn-danger d-flex align-items-center gap-1 ms-3"
                    onClick={() => window.open('https://wa.me/94770792979', '_blank')}
                >
                    <FaCreditCard /> Notify Support
                </button>
            </div>
        </div>
    );
};

export default SubscriptionBanner;
